<template>
    <MetricsTabs tab-key="storage-usage">
        <form class="p-6" @submit.prevent="submit">
            <TextInput
                v-model="date"
                label="Select month"
                type="month"
                class="mb-6 w-40"
            />

            <AtomicButton
                size="md"
                color="yellow"
                type="submit"
                :disabled="loading"
            >
                Send email with CSV export
            </AtomicButton>
        </form>

        <form class="border-t border-gray-200 p-6" @submit.prevent="submitSheet">
            <TextInput
                v-model="sheetMonth"
                label="Select month"
                type="month"
                class="mb-6 w-40"
            />

            <AtomicButton
                size="md"
                color="yellow"
                type="submit"
                :disabled="sheetLoading"
            >
                Generate Google Sheet tab
            </AtomicButton>

            <p class="mt-2 text-sm text-gray-500">Adds a tab for the selected month to the monthly storage usage spreadsheet. If the tab already exists, a numbered one is created instead, e.g. 2026-07 (1).</p>
        </form>
    </MetricsTabs>
</template>

<script lang="ts" setup>
import axios from 'axios';
import { route } from 'ziggy-js';
import { ref } from 'vue';
import { create as createNotification } from '@composables/useNotifications';

const date = ref('');
const loading = ref(false);
const submit = async () => {
    loading.value = true;
    try {
        const result = await axios.post(
            route('kiosk.metrics.storage-usage.store'),
            {
                date: date.value,
            }
        );

        if (result.status === 200) {
            createNotification({
                type: 'success',
                title: 'Storage Usage sent successfully',
            });
        } else {
            createNotification({
                type: 'error',
                title: 'Something went wrong',
            });
        }
    } catch (err) {
        createNotification({
            type: 'error',
            title: 'Something went wrong',
        });
    } finally {
        loading.value = false;
    }
};

const lastMonth = new Date();
lastMonth.setDate(1);
lastMonth.setMonth(lastMonth.getMonth() - 1);
const sheetMonth = ref(
    `${lastMonth.getFullYear()}-${String(lastMonth.getMonth() + 1).padStart(2, '0')}`
);
const sheetLoading = ref(false);
const submitSheet = async () => {
    sheetLoading.value = true;
    try {
        const result = await axios.post(
            route('kiosk.metrics.storage-usage-sheet.store'),
            {
                month: sheetMonth.value,
            }
        );

        if (result.status === 200) {
            createNotification({
                type: 'success',
                title: 'Google Sheet generation queued',
            });
        } else {
            createNotification({
                type: 'error',
                title: 'Something went wrong',
            });
        }
    } catch (err) {
        createNotification({
            type: 'error',
            title: 'Something went wrong',
        });
    } finally {
        sheetLoading.value = false;
    }
};
</script>

<style></style>
